import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Typography, Card, CardContent, useTheme } from "@mui/material";
import { IServiceCardProps } from "../../interfaces";

const ServiceCard: React.FC<IServiceCardProps> = ({
  service,
  index,
  isSelected,
  handleClick
}) => {

  const theme = useTheme();
  return (
    <Card
      onClick={()=>handleClick(index)}
      sx={{
        cursor: "pointer",
        minHeight: 200,
        height: "100%",
        transition: "all 0.3s ease-in-out",
        backgroundColor: isSelected
          ? theme.palette.primary.dark
          : theme.palette.background.paper,
        color: isSelected ? "white" : theme.palette.text.primary,
        border: `2px solid ${
          isSelected ? theme.palette.primary.main : theme.palette.divider
        }`,
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: theme.shadows[4],
          borderColor: theme.palette.primary.main,
        },
      }}
    >
      <CardContent sx={{ p: 3, textAlign: "center" }}>
        <Box
          sx={{
            backgroundColor: isSelected ? "white" : theme.palette.primary.main,
            color: isSelected ? theme.palette.primary.main : "white",
            borderRadius: "50%",
            width: 60,
            height: 60,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2,
          }}
        >
          <FontAwesomeIcon icon={service.icon} size="lg" />
        </Box>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
          {service.title}
        </Typography>
        <Typography variant="body2" sx={{ opacity: isSelected ? 0.9 : 0.7 }}>
          {service.description}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ServiceCard;
